import { Component } from '@angular/core';
import { NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../globals';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';

/**
 * Component que a traves de un array de Allergens muestra su icona
 *
 * Paso a crear:
 * Poder escoger el tamaño del icono
 */

@Component({
  selector: 'page-help',
  templateUrl: 'help.html',
})
export class HelpPage {
  public help_msg: any;
  public help_asunto: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    public http: HttpClient,
    public toastCtrl: ToastController,
    public translate: TranslateService) {

    this.globals.GAtrackView('Help', 'Help - View', this.globals.restaurant.email, 'View', 'View help', 'Help', '');

  }

  sendHelpSlack() {
    this.sendSlackMethodPayment();
  }

  async sendSlackMethodPayment() {
    if (this.help_msg && this.help_asunto) {
      //generate msg
      var msg = 'De ' + this.globals.restaurant.company + ' email: ' + this.globals.restaurant.email + ' con dirección: ' + this.globals.restaurant.address + ' desde cliente ' + this.globals.restaurant.provider + ' Asunto: ' + this.help_asunto + ' Mensaje: ' + this.help_msg;
      //send
      await this.http.post(this.globals.api_path + 'slack/help', {
        msg: msg,
      }, {}).subscribe(async data => {
        let toast = this.toastCtrl.create({
          message: this.translate.instant('instant-consulta-enviada-correctamente'),
          duration: 3000,
          position: 'bottom'
        });
        this.help_msg = '';
        this.help_asunto = '';
        toast.present();
      },
        err => {
        }
      );
    } else {
      //toast
      let toast = this.toastCtrl.create({
        message: this.translate.instant('help-rellena-todos-los-campos'),
        duration: 3000,
        position: 'bottom'
      });
      toast.present();
    }
  }


  openTutorial() {
    if (this.globals.so_mobile) {
      window.location.assign('https://www.mycheftool.com/storage/app/media/tutorial_mct_4.0.pdf');
    } else {
      window.open('https://www.mycheftool.com/storage/app/media/tutorial_mct_4.0.pdf', '_blank');
    }
  }

  openFAQS() {
    if (this.globals.so_mobile) {
      window.location.assign('http://www.mycheftool.com/faqs');
    } else {
      window.open('http://www.mycheftool.com/faqs', '_blank');
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/help/help.ts